const navLinks = [
  { href: '#platforms', label: 'เลือกแพลตฟอร์ม', icon: 'ri-layout-grid-line' },
  { href: '#mt4-guide', label: 'คู่มือ MT4', icon: 'ri-computer-line' },
  { href: '#mt5-guide', label: 'คู่มือ MT5', icon: 'ri-macbook-line' },
  { href: '#compare', label: 'เปรียบเทียบ', icon: 'ri-scales-3-line' },
  { href: '#demo', label: 'ขั้นตอนใช้งาน', icon: 'ri-cursor-line' },
  { href: '#roadmap', label: 'เส้นทางการเรียนรู้', icon: 'ri-route-line' },
  { href: '#faq', label: 'คำถามที่พบบ่อย', icon: 'ri-question-line' },
];

export default function SectionNav() {
  return (
    <nav aria-label="เมนูภายในหน้า" className="border-b border-background-200 bg-background-100/60">
      <div className="mx-auto w-full max-w-7xl px-4 py-3 md:px-6 lg:px-10">
        <div className="flex items-center gap-2 overflow-x-auto no-scrollbar">
          <span className="hidden shrink-0 pr-1 text-xs font-medium text-foreground-500 sm:block">ในหน้านี้</span>
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full border border-background-200 bg-background-50 px-3 py-1.5 text-xs font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              <i className={`${link.icon} text-sm`} />
              {link.label}
            </a>
          ))}
        </div>
      </div>
    </nav>
  );
}